import { Controller, useFormContext } from 'react-hook-form';
import { Checkbox } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import NgpField from './NgpField';
import NgpFieldHelpTip from './NgpFieldHelpTip';

export default function NgpCheckbox({ fieldName, label, helpTipText, disabled = false }) {
    const { control, errors } = useFormContext();

    return (
        <NgpField errors={errors} fieldName={fieldName}>
            <Controller
                control={control}
                name={fieldName}
                defaultValue={false}
                render={({ value = false, onChange }) => (
                    <FormControlLabel
                        control={
                            <Checkbox
                                onChange={(e) => onChange(e.target.checked)}
                                checked={value}
                                disabled={disabled}
                            />
                        }
                        label={label}
                    />
                )}
            />
            {helpTipText && <NgpFieldHelpTip isToggleField helpText={helpTipText} />}
        </NgpField>
    );
}
